import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { productType } from '../../types';
import { getProductType } from '../../utils/ProductTypes';

AuctionHeaderProduct.propTypes = {
    product: productType.isRequired,
    activeProductType: PropTypes.string,
};

AuctionHeaderProduct.defaultProps = {
    activeProductType: null,
};

function AuctionHeaderProduct(props) {
    const {
        product,
        activeProductType,
    } = props;
    const { t } = useTranslation();
    return (
        <>
            <div className="auction-header--product">
                {product.productId}
                {product.iconSymbol && (
                    <>
                        &nbsp;
                        <FontAwesomeIcon icon={product.iconSymbol} style={{ color: product.iconColor }} className="auction-header--product--icon" />
                    </>
                )}
            </div>
            {activeProductType === 'ALL' && (
                <div className="auction-header--product-type">
                    {getProductType(product.productType).translate(t)}
                </div>
            )}
        </>
    );
}

export default AuctionHeaderProduct;
